/**
 * Copyright IBM Corp. 2022, 2026
 */

'use client'

import type { ThumbnailProps } from '../types'
import { useMDSImage } from '../../../utils/mds-context'
import s from '../style.module.css'

export const Thumbnail = ({ src, alt }: ThumbnailProps) => {
	const Image = useMDSImage()

	return (
		<div className={s.thumbnail} data-testid="wpl-card-thumbnail">
			<div className={s.image}>
				<Image src={src} alt={alt} width={800} height={450} />
			</div>
		</div>
	)
}

Thumbnail.displayName = 'Thumbnail'

export const PersonThumbnail = ({ src, alt }: ThumbnailProps) => {
	const Image = useMDSImage()

	return (
		<div className={s.personThumbnail} data-testid="wpl-card-thumbnail">
			<div className={s.image}>
				<Image src={src} alt={alt} width={800} height={450} />
			</div>
		</div>
	)
}

PersonThumbnail.displayName = 'PersonThumbnail'

export const LogoThumbnail = ({ src, alt }: ThumbnailProps) => {
	const Image = useMDSImage()

	return (
		<div className={s.logoThumbnail} data-testid="wpl-card-logo-thumbnail">
			<div className={s.image}>
				<Image src={src} alt={alt} width={800} height={450} />
			</div>
		</div>
	)
}

LogoThumbnail.displayName = 'LogoThumbnail'
